// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"DocuSign_pageContainer__3_skF","tabSwitch":"DocuSign_tabSwitch__i-Fcv","pageLoader":"DocuSign_pageLoader__1GECQ"};